import { Link } from '@mui/material'
import { format, parseISO } from 'date-fns'
import { useDownloadFile } from '~/features/inventory/hooks/useDownloadFile'
import { useDownload } from '~/features/hooks/useDownload'

const formatFilenameDate = (filename: string) => {
  // Match complete ISO date pattern including milliseconds and timezone
  const dateMatch = filename.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/)
  if (!dateMatch) return filename

  try {
    const date = parseISO(dateMatch[0])
    // Return only the formatted date
    return format(date, 'dd/MM/yyyy')
  } catch {
    return filename
  }
}

export const DownloadImportFileLink = ({ filename }: { filename: string }) => {
  const { mutateAsync } = useDownloadFile()
  const { handleDownload } = useDownload()

  const handleClick = async () => {
    const blob = await mutateAsync(filename)
    handleDownload(blob, filename)
  }

  return (
    <Link underline="hover" onClick={handleClick} sx={{ cursor: 'pointer' }}>
      {formatFilenameDate(filename)}
    </Link>
  )
}
